var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanceled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM4.46432 11.9246C4.26906 11.7294 4.26906 11.4128 4.46432 11.2175L7.29276 8.3891L4.46432 5.56066C4.26906 5.3654 4.26906 5.04882 4.46432 4.85355C4.65958 4.65829 4.97616 4.65829 5.17142 4.85355L7.99986 7.68199L10.8283 4.85358C11.0235 4.65831 11.3401 4.65831 11.5354 4.85358C11.7306 5.04884 11.7306 5.36542 11.5354 5.56068L8.70697 8.3891L11.5354 11.2175C11.7306 11.4128 11.7306 11.7294 11.5354 11.9246C11.3401 12.1199 11.0235 12.1199 10.8283 11.9246L7.99986 9.0962L5.17142 11.9246C4.97616 12.1199 4.65958 12.1199 4.46432 11.9246Z",
    fill: "#141E30",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanceled);
export default __webpack_public_path__ + "static/media/canceled.0ef2bc30.svg";
export { ForwardRef as ReactComponent };